/*
 * Party Social — Balloon Designer.
 * Paired with sections/balloon-designer.liquid. All product data is rendered into
 * the page by Liquid (so stock and pricing are live); this file only ranks it,
 * draws it and posts the chosen pieces to the cart.
 */
(function () {
  'use strict';

  var root = document.getElementById('ps-balloon-designer');
  if (!root) return;

  /* ---------- data ---------- */

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || el.innerText || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  var COLOURS = readJSON('ps-balloon-colours').filter(function (c) { return c && c.n; });

  // A product can sit in more than one collection (a helium bouquet is in both
  // "Balloon Bouquet" and "Helium Balloons"). Merge those into one entry and
  // union their placements, or the same piece is offered twice.
  var PRODUCTS = (function () {
    var byKey = {};
    var out = [];
    readJSON('ps-balloon-products').forEach(function (p) {
      if (!p || !p.v || !p.u) return;
      var places = String(p.pl || '').split(',').filter(Boolean);
      // product.url can be rendered with a /collections/<handle> prefix, so the
      // product handle is the identity, not the URL.
      var key = String(p.u).replace(/^.*\/products\//, '').split('?')[0];
      var existing = byKey[key];
      if (existing) {
        places.forEach(function (pl) {
          if (existing.places.indexOf(pl) === -1) existing.places.push(pl);
        });
        return;
      }
      var entry = {
        title: p.t || '',
        key: key,
        url: p.u,
        variant: String(p.v),
        price: typeof p.p === 'number' ? p.p : 0,
        img: p.img || '',
        tags: Array.isArray(p.tags) ? p.tags : [],
        quote: p.q === true,
        kind: p.k || 'Balloons',
        places: places,
        available: p.a !== false
      };
      entry.haystack = (entry.title + ' ' + entry.tags.join(' ')).toLowerCase();
      byKey[key] = entry;
      out.push(entry);
    });
    return out;
  })();

  var OCCASION_WORDS = {
    birthday: ['birthday', 'milestone', 'foil number', 'number balloon'],
    baby: ['baby', 'gender reveal', 'bearly wait', 'tiny miracle', 'one-derful', 'giraffe', 'stork'],
    graduation: ['graduation', 'grad', 'prom', 'back to school', 'back-to-school', 'graduate'],
    wedding: ['wedding', 'engagement', 'she said yes', 'floating on yes', 'bride', 'nikah', 'boundless love', 'lucky in love', 'blooming elegance', 'pearl celebration'],
    anniversary: ['anniversary', 'valentine', 'love', 'heart', 'romance', 'blush rose', 'soft luxe'],
    seasonal: ['halloween', 'christmas', 'diwali', 'thanksgiving', 'autumn', 'new year', 'eid', 'spooky', 'pumpkin', 'ghost', 'witch', 'skeleton'],
    corporate: ['black & gold', 'golden glam', 'prestige', 'signature', 'majestic', 'moulded', 'sequin', 'chrome', 'launch'],
    other: []
  };

  var OCCASION_LABEL = {
    birthday: 'Birthday', baby: 'Baby shower', graduation: 'Graduation',
    wedding: 'Wedding', anniversary: 'Anniversary', seasonal: 'Seasonal',
    corporate: 'Corporate', other: 'Just because'
  };

  var PLACEMENT_LABEL = {
    table: 'On the tables', floor: 'On the floor', entrance: 'At the entrance',
    wall: 'Photo wall', floating: 'Floating', diy: 'Styled myself'
  };

  var SCALE_LABEL = { simple: 'Simple', statement: 'Statement', showstopper: 'Showstopper' };
  var SCALE_TARGET = { simple: 0, statement: 1, showstopper: 2 };
  var SCALE_COUNT = { simple: 2, statement: 2, showstopper: 3 };
  var MAX_SUGGESTIONS = 8;

  /* ---------- state ---------- */

  var state = {
    step: 1,
    occasion: 'birthday',
    colours: [],
    placements: ['table'],
    scale: 'statement',
    picked: {},          // product handle -> true
    suggestions: []
  };

  var TOTAL_STEPS = 5;
  var currency = root.getAttribute('data-currency') || 'AED';
  var cartUrl = root.getAttribute('data-cart-url') || '/cart';
  var cartAddUrl = (root.getAttribute('data-cart-add-url') || '/cart/add') + '.js';
  var quoteVariant = root.getAttribute('data-quote-variant') || '';

  /* ---------- helpers ---------- */

  function money(cents) {
    var v = (cents || 0) / 100;
    var s = v % 1 === 0 ? String(Math.round(v)) : v.toFixed(2);
    var bits = s.split('.');
    bits[0] = bits[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return currency + ' ' + bits.join('.');
  }

  function priceBand(cents) {
    if (cents < 25000) return 0;
    if (cents < 100000) return 1;
    return 2;
  }

  function occasionScore(product) {
    var words = OCCASION_WORDS[state.occasion] || [];
    var hits = 0;
    for (var i = 0; i < words.length; i++) {
      if (product.haystack.indexOf(words[i]) !== -1) hits++;
    }
    return hits;
  }

  function score(product, placement) {
    // DIY packets are cheap by nature, so the scale target doesn't apply there.
    var target = placement === 'diy' ? 0 : SCALE_TARGET[state.scale];
    var distance = Math.min(2, Math.abs(priceBand(product.price) - target));
    var fit = 1 - distance * 0.45;
    return occasionScore(product) * 2 + fit + (product.available ? 0.3 : 0);
  }

  function buildSuggestions() {
    var seen = {};
    var out = [];
    var perPlacement = SCALE_COUNT[state.scale] || 2;

    state.placements.forEach(function (placement) {
      var pool = PRODUCTS.filter(function (p) {
        return p.places.indexOf(placement) !== -1 && !seen[p.key];
      });
      pool.sort(function (a, b) {
        var d = score(b, placement) - score(a, placement);
        if (d !== 0) return d;
        return a.price - b.price;
      });
      pool.slice(0, perPlacement).forEach(function (p) {
        if (out.length >= MAX_SUGGESTIONS) return;
        seen[p.key] = true;
        out.push({ product: p, placement: placement });
      });
    });

    return out;
  }

  /* ---------- rendering ---------- */

  function renderSwatches() {
    var wrap = document.getElementById('ps-swatches');
    if (!wrap) return;
    if (!COLOURS.length) {
      wrap.innerHTML = '';
      return;
    }
    wrap.innerHTML = COLOURS.map(function (c) {
      var img = c.img
        ? '<img src="' + c.img + '" alt="" loading="lazy" onerror="this.remove()">'
        : '';
      return '<button class="ps-swatch-btn" type="button" data-colour="' + escapeAttr(c.n) + '" aria-pressed="false">' +
             '<span class="ps-chip">' + img + '</span><small>' + escapeHtml(c.n) + '</small></button>';
    }).join('');

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.ps-swatch-btn');
      if (!btn) return;
      var name = btn.getAttribute('data-colour');
      var i = state.colours.indexOf(name);
      if (i === -1) {
        if (state.colours.length >= 4) {
          setPaletteNote('That’s four already — remove one to swap it out.');
          return;
        }
        state.colours.push(name);
        btn.setAttribute('aria-pressed', 'true');
      } else {
        state.colours.splice(i, 1);
        btn.setAttribute('aria-pressed', 'false');
      }
      setPaletteNote();
    });
  }

  function setPaletteNote(message) {
    var note = document.getElementById('ps-palette-note');
    if (!note) return;
    if (message) { note.textContent = message; return; }
    note.textContent = state.colours.length
      ? 'Your palette: ' + state.colours.join(', ')
      : 'No colours picked yet — you can skip this and leave it to us.';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  function renderRecap() {
    var recap = document.getElementById('ps-recap');
    if (!recap) return;
    var bits = [
      ['Occasion', OCCASION_LABEL[state.occasion]],
      ['Where', state.placements.map(function (p) { return PLACEMENT_LABEL[p]; }).join(', ')],
      ['Scale', SCALE_LABEL[state.scale]]
    ];
    if (state.colours.length) bits.push(['Colours', state.colours.join(', ')]);
    recap.innerHTML = bits.map(function (b) {
      return '<span class="ps-tag">' + escapeHtml(b[0]) + ': <strong>' + escapeHtml(b[1]) + '</strong></span>';
    }).join('');
  }

  function renderCards() {
    var wrap = document.getElementById('ps-cards');
    var empty = document.getElementById('ps-empty');
    if (!wrap) return;

    if (!state.suggestions.length) {
      wrap.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    wrap.innerHTML = state.suggestions.map(function (s) {
      var p = s.product;
      var picked = state.picked[p.key] === true;
      var img = p.img
        ? '<img src="' + p.img + '" alt="" loading="lazy" onerror="this.remove()">'
        : '';
      var priceLine = p.quote
        ? '<span class="ps-quote-flag">Quote</span> · from ' + money(p.price)
        : money(p.price);
      var soldout = p.available ? '' : ' <span class="ps-soldout">· currently out of stock</span>';
      return '' +
        '<article class="ps-card' + (picked ? ' is-picked' : '') + '" data-key="' + escapeAttr(p.key) + '">' +
          '<div class="ps-card-img">' + img + '</div>' +
          '<div class="ps-card-body">' +
            '<div class="ps-card-kind">' + escapeHtml(p.kind) + ' · ' + escapeHtml(PLACEMENT_LABEL[s.placement] || '') + '</div>' +
            '<h4>' + escapeHtml(p.title) + '</h4>' +
            '<div class="ps-card-price">' + priceLine + soldout + '</div>' +
            '<div class="ps-card-actions">' +
              '<button class="ps-pick" type="button" data-pick>' + (picked ? 'Added' : 'Add') + '</button>' +
              '<a class="ps-view" href="' + escapeAttr(p.url) + '" target="_blank" rel="noopener">View</a>' +
            '</div>' +
          '</div>' +
        '</article>';
    }).join('');
  }

  function renderSummary() {
    var titleEl = document.getElementById('ps-summary-title');
    var copyEl = document.getElementById('ps-summary-copy');
    var totalEl = document.getElementById('ps-summary-total');
    var submit = document.getElementById('ps-submit');
    var quoteFields = document.getElementById('ps-quote-fields');
    var note = document.getElementById('ps-cta-note');

    var chosen = state.suggestions
      .map(function (s) { return s.product; })
      .filter(function (p) { return state.picked[p.key] === true; });

    var cartItems = chosen.filter(function (p) { return !p.quote && p.available; });
    var quoteItems = chosen.filter(function (p) { return p.quote || !p.available; });
    var cartTotal = cartItems.reduce(function (sum, p) { return sum + p.price; }, 0);

    if (quoteFields) quoteFields.hidden = quoteItems.length === 0;
    if (submit) submit.disabled = chosen.length === 0;

    if (!chosen.length) {
      if (titleEl) titleEl.textContent = 'Your selection';
      if (copyEl) copyEl.textContent = 'Pick at least one piece above to continue.';
      if (totalEl) totalEl.textContent = '';
      if (submit) submit.textContent = 'Add my design to the cart';
      if (note) note.textContent = 'Nothing is charged for a quote request — we price it and come back to you.';
      return;
    }

    if (titleEl) {
      titleEl.textContent = chosen.length === 1 ? '1 piece selected' : chosen.length + ' pieces selected';
    }

    var parts = [];
    if (cartItems.length) parts.push(cartItems.length + (cartItems.length === 1 ? ' piece goes straight to your cart' : ' pieces go straight to your cart'));
    if (quoteItems.length) parts.push(quoteItems.length + (quoteItems.length === 1 ? ' piece is built on site, so it goes to us as a quote request' : ' pieces are built on site, so they go to us as a quote request'));
    if (copyEl) copyEl.textContent = parts.join(', and ') + '.';

    if (totalEl) {
      totalEl.innerHTML = cartItems.length
        ? 'Cart subtotal: <strong>' + money(cartTotal) + '</strong>' + (quoteItems.length ? ' · the quote request is added at AED 0.' : '')
        : 'Nothing is charged — this goes to us as a quote request.';
    }

    if (submit) {
      submit.textContent = cartItems.length
        ? (quoteItems.length ? 'Add to cart and request a quote' : 'Add my design to the cart')
        : 'Send this as a quote request';
    }
    if (note) {
      note.textContent = quoteItems.length
        ? 'We’ll price the installation and come back to you — nothing is charged for it now.'
        : 'You can keep shopping or check out from your cart.';
    }
  }

  function renderResult() {
    state.suggestions = buildSuggestions();
    state.picked = {};
    // Pre-select the strongest suggestion per placement so the summary isn't empty.
    var seenPlacement = {};
    state.suggestions.forEach(function (s) {
      if (!seenPlacement[s.placement] && s.product.available) {
        seenPlacement[s.placement] = true;
        state.picked[s.product.key] = true;
      }
    });
    renderRecap();
    renderCards();
    renderSummary();
  }

  /* ---------- steps ---------- */

  function showStep(n, scroll) {
    state.step = n;
    root.querySelectorAll('.ps-step').forEach(function (el) {
      el.hidden = Number(el.getAttribute('data-step')) !== n;
    });
    var label = document.getElementById('ps-step-label');
    if (label) label.textContent = 'Step ' + n + ' of ' + TOTAL_STEPS;
    var fill = document.getElementById('ps-progress-fill');
    if (fill) fill.style.width = (n / TOTAL_STEPS * 100) + '%';
    if (n === 5) renderResult();
    if (scroll !== false) {
      try {
        var top = root.getBoundingClientRect().top + window.pageYOffset - 20;
        window.scrollTo({ top: top, behavior: 'smooth' });
      } catch (e) { /* older browsers */ }
    }
  }

  /* ---------- wiring ---------- */

  root.addEventListener('click', function (e) {
    var option = e.target.closest('.ps-option');
    if (option) {
      var group = option.parentElement.getAttribute('data-group');
      var value = option.getAttribute('data-value');
      if (group === 'placement') {
        var on = option.getAttribute('aria-pressed') === 'true';
        if (on && state.placements.length === 1) return; // keep at least one
        option.setAttribute('aria-pressed', on ? 'false' : 'true');
        state.placements = Array.prototype.slice
          .call(option.parentElement.querySelectorAll('.ps-option[aria-pressed="true"]'))
          .map(function (b) { return b.getAttribute('data-value'); });
      } else {
        option.parentElement.querySelectorAll('.ps-option').forEach(function (b) {
          b.setAttribute('aria-pressed', b === option ? 'true' : 'false');
        });
        if (group === 'occasion') state.occasion = value;
        if (group === 'scale') state.scale = value;
      }
      return;
    }

    if (e.target.closest('[data-next]')) { showStep(Math.min(TOTAL_STEPS, state.step + 1)); return; }
    if (e.target.closest('[data-back]')) { showStep(Math.max(1, state.step - 1)); return; }
    if (e.target.closest('[data-start]')) { showStep(1); return; }

    var pick = e.target.closest('[data-pick]');
    if (pick) {
      var card = pick.closest('.ps-card');
      if (!card) return;
      var key = card.getAttribute('data-key');
      state.picked[key] = !state.picked[key];
      card.classList.toggle('is-picked', state.picked[key] === true);
      pick.textContent = state.picked[key] ? 'Added' : 'Add';
      renderSummary();
      return;
    }

    if (e.target.closest('#ps-submit')) { submitDesign(); }
  });

  /* ---------- cart ---------- */

  function showError(message) {
    var el = document.getElementById('ps-error');
    if (!el) return;
    if (!message) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.textContent = message;
  }

  function baseProperties() {
    var props = { 'Designed with': 'Balloon Designer' };
    if (state.colours.length) props['Colour palette'] = state.colours.join(', ');
    return props;
  }

  function submitDesign() {
    var submit = document.getElementById('ps-submit');
    showError('');

    var chosen = state.suggestions
      .map(function (s) { return s.product; })
      .filter(function (p) { return state.picked[p.key] === true; });
    if (!chosen.length) return;

    var cartItems = chosen.filter(function (p) { return !p.quote && p.available; });
    var quoteItems = chosen.filter(function (p) { return p.quote || !p.available; });

    var items = cartItems.map(function (p) {
      return { id: Number(p.variant), quantity: 1, properties: baseProperties() };
    });

    if (quoteItems.length) {
      if (!quoteVariant) {
        showError('The quote request item isn’t set up yet. Please contact us and we’ll take the brief directly.');
        return;
      }
      var dateEl = document.getElementById('ps-event-date');
      var venueEl = document.getElementById('ps-venue');
      var props = {
        'Occasion': OCCASION_LABEL[state.occasion],
        'Where it goes': state.placements.map(function (p) { return PLACEMENT_LABEL[p]; }).join(', '),
        'Scale': SCALE_LABEL[state.scale],
        'Pieces to quote': quoteItems.map(function (p) {
          return p.title + ' (from ' + money(p.price) + ')';
        }).join(' | '),
        'Designed with': 'Balloon Designer'
      };
      if (state.colours.length) props['Colour palette'] = state.colours.join(', ');
      if (dateEl && dateEl.value) props['Event date'] = dateEl.value;
      if (venueEl && venueEl.value.trim()) props['Venue'] = venueEl.value.trim();
      items.push({ id: Number(quoteVariant), quantity: 1, properties: props });
    }

    if (!items.length) {
      showError('Everything you picked is out of stock right now. Try another piece, or send us the brief.');
      return;
    }

    if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (!r.ok) {
          throw new Error((r.data && (r.data.description || r.data.message)) || 'We couldn’t add that to your cart.');
        }
        window.location.href = cartUrl;
      })
      .catch(function (err) {
        showError(err.message || 'Something went wrong adding this to your cart. Please try again.');
        if (submit) { submit.disabled = false; }
        renderSummary();
      });
  }

  /* ---------- init ---------- */

  renderSwatches();
  setPaletteNote();
  showStep(1, false);
})();
